import { IMediaRecorder } from 'extendable-media-recorder'

export const stopRecording = async (
  recorder: React.MutableRefObject<IMediaRecorder | null>,
  stream: React.MutableRefObject<MediaStream | null>,
  isRecording: React.MutableRefObject<boolean>,
): Promise<void> => {
  /*
  Used to stop recording and audio streaming
  Args:
    recorder:        (React.MutableRefObject<IMediaRecorder | null>):
    stream:             (React.MutableRefObject<MediaStream | null>):
    isRecording:                   (React.MutableRefObject<boolean>):
  Returns:
    void
  */
  if (!recorder.current) {
    throw new Error('Recorder must not be null')
  }
  if (!stream.current) {
    throw new Error('Stream must not be null')
  }
  if (recorder.current) {
    console.info('Terminating recording')
    recorder.current.stop()
    stream.current.getTracks().forEach((track) => track.stop())
    isRecording.current = false
    recorder.current = null
    stream.current = null
  }
}
